/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_FinnishInputs */



/**
* | output |
* | --- |
* | "Finnish" |
*
* @param {Speechmatics_Target_Language_FinnishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_finnish = /** @type {((inputs?: Speechmatics_Target_Language_FinnishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_FinnishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finnois")
	if (locale === "de") return /** @type {LocalizedString} */ ("finnisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("finlandese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("финский")
	if (locale === "es") return /** @type {LocalizedString} */ ("finlandés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("芬兰")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィンランド語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिनिश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("finlandês")
	return /** @type {LocalizedString} */ ("Finnish")
});